import { Component, OnInit, Input } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { Detail } from '../../../models/detail';

import { AlertService } from '../../../services/common/alert.service';
import { DetailService } from '../../../services/matters/detail.service';

@Component({
  selector: 'app-matter-detail-index',
  templateUrl: './matter-detail-index.component.html',
  styleUrls: ['./matter-detail-index.component.css'],
})
export class MatterDetailIndexComponent implements OnInit {
  @Input() matter_id: number;

  details: Array<Detail> = [];
  matter_details: any = {};

  search_params: any = {};

  loading: boolean = true;

  showNewDetailForm: boolean = false;

  detailToBeDeleted: Detail | null;

  sortOptions: any = {
    ghostClass: 'ghost-class',
    chosenClass: 'chosen-class',
    dragClass: 'drag-class',
    handle: '.draggable-elem',
    onUpdate: (event: any) => {
      this.updatePosition();
    },
  };

  constructor(private alertService: AlertService, private detailService: DetailService, private modalService: NgbModal) {}

  ngOnInit() {
    if (this.matter_id) this.loadDetails();
  }

  loadDetails() {
    this.search_params.matter_id = this.matter_id;
    this.detailService.getDetails(this.search_params).then((response_json) => {
      this.loading = false;
      this.details = response_json.details;
      this.matter_details = response_json.matter_details;
    });
  }

  editDetail(detail: Detail) {
    detail.editing = true;
  }

  updatePosition() {
    let detail_ids: Array<number> = [];
    for (let detail of this.details) {
      detail_ids.push(detail.id);
    }
    let scope = this;
    this.detailService
      .updatePosition(detail_ids)
      .then((response_json) => {
        if (response_json.text != 'Position updated') this.alertService.alert_status_danger('Error updating position of detail');
      })
      .catch(function () {
        scope.alertService.alert_status_danger('Error updating position of detail');
      });
  }

  formResult(event: any, detail: Detail | null = null) {
    if (event == 'Form Cancelled') {
      if (detail) detail.editing = false;
      else this.showNewDetailForm = false;
    } else if (event == 'Form Saved') {
      if (detail) detail.editing = false;
      else this.showNewDetailForm = false;
      this.loadDetails();
    }
  }

  confirmDetailDelete(detail: Detail, modal: any) {
    this.detailToBeDeleted = detail;
    this.modalService.open(modal).result.then(
      (result) => {
        this.deleteDetail();
      },
      (reason) => {}
    );
  }

  deleteDetail() {
    this.detailToBeDeleted!.deleting = true;
    let scope = this;
    this.detailService
      .deleteDetail(this.detailToBeDeleted!)
      .then((response_json) => {
        this.detailToBeDeleted!.deleting = false;
        this.detailToBeDeleted = null;
        if (response_json.text == 'Detail deleted') {
          this.loadDetails();
          this.alertService.alert_status_success(response_json.text);
        } else this.alertService.alert_status_danger(response_json.text || 'Error deleting detail');
      })
      .catch(function () {
        scope.alertService.alert_status_danger('Error deleting detail');
        scope.detailToBeDeleted!.deleting = false;
        scope.detailToBeDeleted = null;
      });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
}
